import React, { useState, useEffect, useRef } from "react";
import * as R from "ramda";
import {
  Elements,
  CardElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { initializePaddle } from "@paddle/paddle-js";
import { apiConfig } from "../api/api";
import { loginEmailHint, rememberLoginEmail } from "../../routers/openStore";
import { loadStripe } from "@stripe/stripe-js";
import { Form } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { connect } from "react-redux";
import {
  handleLoginFormLoginRequest,
  handleRegisterFormRequest,
  setRegisterError,
  getSubscriptionType,
  getPromoCode,
  clearPromoCode,
  setHasPromoCode,
  createRegistrationQuote,
  updateRegistrationQuote,
  deleteRegistrationQuote,
  getRegistrationQuote,
  setReferralCode,
} from "./userSession.redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import logo from "../../images/spectre_logo_2022.png";
import Notify from "../ui/Notify";
import theme from "../../theme/feedback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { validation } from "../../const";
import { isValid, checkValidValue, getCountries, getStates } from "../../utils";
import { paddleCheckout } from "../../utils/paddleCheckout";
import { serialize, validate } from "formee";
import TailSpin from "../ui/Loader";

import { LoadingPage } from "../ui/LoadingPage";

const isStripe = apiConfig.payment_gateway === "STRIPE";
const isPaddle = apiConfig.payment_gateway === "PADDLE";

const Title = styled.h1`
  font-family: ${theme.font.family};
  font-size: 1.75em;
  text-align: center;
  color: ${theme.color.text};
  margin-bottom: ${theme.spacing.lg};
  font-weight: ${theme.font.weightBold};
`;

const TitleCreate = styled.h1`
  font-family: ${theme.font.family};
  font-size: 1.15em;
  text-align: left;
  color: ${theme.color.primary};
  margin: ${theme.spacing.md} 0 ${theme.spacing.sm} 0;
  font-weight: ${theme.font.weightBold};
`;

const TotalLabel = styled.div`
  width: 100%;
  font-size: 1em;
  text-align: right;
  color: #00197b;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

const SpinnerContainer = styled.div`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PolicyLabel = styled.span`
  text-align: center;
  font-family: ${theme.font.family};
  font-size: ${theme.font.sizeSm};
  letter-spacing: 0px;
  color: ${theme.color.textMuted};
  opacity: 1;
  margin-top: ${theme.spacing.md};
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: nowrap;
`;

const FooterLabel = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  font: normal normal normal 20px Poppins;
  letter-spacing: 0px;
  color: #00197b;
  opacity: 1;
  background-color: #ffffff;
  width: 100%;
  padding: 0.5em;

  @media (orientation: Portrait) {
    font: normal normal normal 14px Poppins;
  }

  @media (max-width: 992px) {
    font: normal normal normal 14px Poppins;
  }
`;

const Button = styled.button`
  font-family: ${theme.font.family};
  background: ${theme.color.primary};
  color: #ffffff;
  border: none;
  border-radius: ${theme.radius.md};
  opacity: 1;
  width: 95%;
  align-self: center;
  height: 48px;
  margin-top: ${theme.spacing.md};
  font-weight: ${theme.font.weightSemibold};
  font-size: ${theme.font.sizeMd};
  letter-spacing: 0.4px;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;

  &:hover {
    background: ${theme.color.primaryDark};
    box-shadow: 0 6px 16px rgba(0, 24, 126, 0.25);
  }
  &:active {
    transform: translateY(1px);
  }

  ${(props) =>
    props.subs &&
    css`
      background: ${theme.color.accent};
      margin-bottom: 3vh;

      &:hover {
        background: #00a7b4;
        box-shadow: 0 6px 16px rgba(0, 190, 204, 0.3);
      }
    `}
`;

const LogoContainer = styled.img`
  width: 100%;
  height: unset;
  aspect-ratio: 588 / 210;
  padding: 0;
  display: flex;
  flex-direction: row;
`;

const SectionContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5em;

  ${(props) =>
    props.right &&
    css`
      @media (orientation: Portrait) {
        justify-content: flex-start;
      }

      @media (max-width: 992px) {
        justify-content: flex-start;
      }
    `}
`;

const SectionContainerCreate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1.5em;
  padding-right: 1.5em;
  margin-bottom: 0;

  ${(props) =>
    props.$twoCol &&
    css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1rem;
      row-gap: 0;
      align-items: start;
      width: 100%;

      & > .col-12 {
        grid-column: 1 / -1;
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    `}
`;

const ImageLabel = styled.span`
  font: normal normal 600 29px/23px Poppins;
  color: #00187e;
  margin: 1vh 0 10vh 0;
  display: flex;
  flex-direction: column;

  @media (orientation: Portrait) {
    margin: 1vh 0 0 0;
  }

  @media (max-width: 992px) {
    margin: 1vh 0 0 0;
  }
`;

const ContainerStyle = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: ${(props) => (props.createAccount ? "flex-start" : "center")};
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  // height: ${(props) => (props.createAccount ? "75vh" : "100vh")};
  height: 95vh;
  background: ${theme.color.surface};

  ${(props) =>
    props.createAccount &&
    css`
      & .row.container-row {
        width: 80%;
      }

      @media (orientation: Portrait) {
        flex-direction: row;
        height: 75vh;
        & .row.container-row {
          width: 100%;
        }
      }

      @media (max-width: 992px) {
        flex-direction: row;
        height: 75vh;
        & .row.container-row {
          width: 100%;
        }
      }
    `}
`;

const CardContainer = styled.div`
  width: 100%;
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.md};
  padding: 1em;
  padding-top: 1.5em;
  height: 58px;

  ${(props) =>
    props.focused &&
    css`
      border-color: ${theme.color.primary};
      box-shadow: 0 0 0 0.2rem rgba(0, 24, 126, 0.15);
    `}

  ${(props) =>
    props.focused &&
    props.invalid &&
    css`
      box-shadow: 0 0 0 0.25rem rgb(220 53 69 / 25%);
    `}
  

  ${(props) =>
    props.invalid &&
    css`
      border-color: #dc3545;
      padding-right: calc(1.5em + 0.75rem);
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 0.1875rem) center;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    `}
`;

const StretchStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  width: -webkit-fill-available;
  flex-direction: column;
  max-width: 440px;
  background: ${theme.color.surface};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.lg};
  box-shadow: 0 12px 32px rgba(21, 34, 50, 0.12);
  padding: ${theme.spacing.xl} ${theme.spacing.lg};

  @media (max-width: 992px) {
    box-shadow: 0 8px 24px rgba(21, 34, 50, 0.12);
    padding: ${theme.spacing.lg} ${theme.spacing.md};
  }
`;

const FormStretchStyle = styled(Form)`
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  width: -webkit-fill-available;
  flex-direction: column;

  .form-control {
    font-family: ${theme.font.family};
    border: 1px solid ${theme.color.border};
    border-radius: ${theme.radius.md};
    color: ${theme.color.text};
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .form-control:focus {
    border-color: ${theme.color.primary};
    box-shadow: 0 0 0 0.2rem rgba(0, 24, 126, 0.15);
  }
  .form-control.is-invalid:focus {
    box-shadow: 0 0 0 0.2rem rgba(214, 40, 40, 0.18);
  }
  .form-floating > label {
    font-family: ${theme.font.family};
    color: ${theme.color.textMuted};
  }

  ${(props) =>
    props.$compact &&
    css`
      .form-floating.mb-3 {
        margin-bottom: ${theme.spacing.sm} !important;
      }
      .form-floating > .form-control {
        height: 48px;
        min-height: 48px;
        font-size: 0.95rem;
      }
      .form-floating > label {
        padding: 0.75rem 0.75rem;
        font-size: 0.95rem;
      }
      .form-floating > .form-control:focus,
      .form-floating > .form-control:not(:placeholder-shown) {
        padding-top: 1.25rem;
        padding-bottom: 0.25rem;
      }
      .form-floating > .form-control:focus ~ label,
      .form-floating > .form-control:not(:placeholder-shown) ~ label {
        transform: scale(0.8) translateY(-0.4rem) translateX(0.15rem);
      }
      & > .row:first-child h1 {
        margin-top: 0;
      }
    `}
`;

const RegisterHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.sm} ${theme.spacing.lg};

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.spacing.sm};
  }
`;

const BackLink = styled.button`
  position: absolute;
  left: ${theme.spacing.lg};
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: ${theme.font.family};
  font-weight: ${theme.font.weightSemibold};
  font-size: ${theme.font.sizeMd};
  color: ${theme.color.primary};

  &:hover {
    color: ${theme.color.primaryDark};
  }

  @media (max-width: 576px) {
    position: static;
    transform: none;
    align-self: flex-start;
  }
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: ${theme.font.family};

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

const RegTitle = styled.span`
  font-size: 24px;
  font-weight: ${theme.font.weightBold};
  color: ${theme.color.primary};

  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

const WelcomeSub = styled.span`
  font-size: ${theme.font.sizeLg};
  color: ${theme.color.textMuted};
  margin-left: ${theme.spacing.md};
  padding-left: ${theme.spacing.md};
  border-left: 2px solid ${theme.color.border};

  @media (max-width: 576px) {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    font-size: ${theme.font.sizeMd};
  }
`;
const logoStyle = {
  verticalAlign: "text-bottom",
  with: "16px",
  height: "16px",
  marginRight: "0.5em",
};

const CardComponent = ({ setCardFocus, setCardInvalid, setCardElement }) => {
  const elements = useElements();
  const stripe = useStripe();

  return (
    <CardElement
      options={{ hidePostalCode: true }}
      onFocus={() => setCardFocus(true)}
      onBlur={() => setCardFocus(false)}
      onChange={(e) => {
        setCardInvalid(e.empty);
        if (e.complete) {
          setCardElement({ element: elements.getElement(CardElement), stripe });
        } else {
          setCardElement({
            element: null,
            stripe: null,
          });
        }
      }}
    />
  );
};

let LoginForm = (props) => {
  const {
    handleLoginFormLoginRequest,
    handleRegisterFormRequest,
    requesting,
    error,
    invalid,
    setRegisterError,
    getSubscriptionType,
    subscriptionType,
    lang,
    appStarted,
    isSandbox,
    registeringUser,
    getPromoCode,
    clearPromoCode,
    validatingPromoCode,
    promoCode,
    isPromoCodeValid,
    showPromoCodeValid,
    showPromoCodeInvalid,
    setHasPromoCode,
    hasPromoCode,
    register,
    createRegistrationQuote,
    updateRegistrationQuote,
    deleteRegistrationQuote,
    getRegistrationQuote,
    registrationQuote,
    deviceInfo,
    locale,
    referralCode,
    setReferralCode,
  } = props;
  // console.log("DEVICE INFO", deviceInfo);

  const { t } = useTranslation();
  const [createAccount, setCreateAccount] = useState(register);
  const [showPassword, setShowPassword] = useState(false);
  const [registerFormValidation, setRegisterFormValidation] = useState({
    firstname: "",
    lastname: "",
    username: "",
    password: "",
    verifyPassword: "",
    billingCountry: "",
    billingFullname: "",
    billingState: "",
    billingCity: "",
    phone: "",
    addressLine1: "",
  });
  const [tipping, setTipping] = useState(false);
  const [cardInvalid, setCardInvalid] = useState(false);
  const [cardFocus, setCardFocus] = useState(false);
  const [cardElement, setCardElement] = useState({
    element: null,
    stripe: null,
  });
  const { EMAIL, REQUIRED, PASSWORD } = validation;
  const [showLogin, setShowLogin] = useState(false);
  const [selectedCountry, SelectCountry] = useState("");
  const [stripeObject, setStripeObject] = useState(null);
  const loginFormRef = useRef();
  const registerFormRef = useRef();
  const showLoginTimeout = useRef();
  const showLoginRef = useRef();
  const countries = getCountries(lang);
  const navigate = useNavigate();
  const defaultFormValues = window
    ? JSON.parse(window.localStorage.getItem("registrationForm")) || {}
    : {};

  showLoginRef.current = false;

  if (error && error !== "") {
    // console.log(error);
  }
  // console.log("invalid", invalid);

  let subscriptionTypeByCountry = [];
  let currency = "USD";
  if (defaultFormValues.billingCountry !== "") {
    subscriptionTypeByCountry = subscriptionType.filter((sType) =>
      // console.log(defaultFormValues.billingCountry) ||
      defaultFormValues.billingCountry === "CA"
        ? sType.description.indexOf("CAD") >= 0
        : sType.description.indexOf("CAD") < 0
    );
    currency = defaultFormValues.billingCountry === "CA" ? "CAD" : currency;
  }
  // console.log(subscriptionType, subscriptionTypeByCountry);

  useEffect(() => {
    if (defaultFormValues.billingCountry !== "") {
      SelectCountry(defaultFormValues.billingCountry);
    }
  }, []);

  useEffect(() => {
    if (appStarted) {
      if (isStripe) {
        const fetchStripeObject = async () => {
          const stripePromise = await loadStripe(apiConfig.stripe_key);
          setStripeObject(stripePromise);
        };
        fetchStripeObject();
      }
    }
  }, [appStarted]);

  useEffect(() => {
    if (!showLoginRef.current) {
      showLoginTimeout.current = setTimeout(() => {
        showLoginRef.current = true;
        setShowLogin(true);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if (createAccount) {
      getRegistrationQuote();
    }
  }, [createAccount]);

  // Keep createAccount in sync with the route's `register` prop so the browser
  // back/forward buttons work. In-app nav (SIGN UP / Back) sets this manually,
  // but the browser buttons only change the route/prop, leaving state stale.
  useEffect(() => {
    setCreateAccount(!!register);
  }, [register]);

  useEffect(() => {
    return () => clearTimeout(showLoginTimeout.current);
  }, []);

  useEffect(() => {
    getSubscriptionType();
  }, []);

  useEffect(() => {
    if (invalid) {
      Notify(`${t(error)}`, "error");
      if (createAccount) {
        setRegisterError({ error: "" });
      }
    }
  }, [error]);

  const handleLogin = () => {
    const form = loginFormRef.current;
    const values = serialize(form, { hash: true });

    handleLoginFormLoginRequest(values);
  };

  const handleBack = () => {
    navigate("/login");
    setCreateAccount(false);
    setTipping(false);
  };

  const handleFocusTextbox = () => {
    setTipping(true);
  };

  const handleSubscription = () => {
    navigate("/register");
    setCreateAccount(true);
    setTipping(false);
  };

  const handleCreateAccount = () => {
    const form = registerFormRef.current;

    const proccessCreateAccount = async () => {
      if (isStripe) {
        const formValidation = validate(form, {
          firstname: REQUIRED,
          lastname: REQUIRED,
          proshopName: REQUIRED,
          billingFullname: REQUIRED,
          billingCountry: REQUIRED,
          billingState: REQUIRED,
          billingCity: REQUIRED,
          addressLine1: REQUIRED,
          phone: REQUIRED,
          coupon: () =>
            hasPromoCode && !isPromoCodeValid
              ? "Invalid Promo Code"
              : undefined,
          // zipCode: (value, data) =>
          //   data.country === "US" || data.country === "CA"
          //     ? REQUIRED(value)
          //     : undefined,
          username: (value) => REQUIRED(value) || EMAIL(value),
          password: (value) => REQUIRED(value) || PASSWORD(value),
          verifyPassword: (value, data) =>
            REQUIRED(value) ||
            PASSWORD(value) ||
            (value !== data.password
              ? "message.error.password_confirmation"
              : undefined),
        });

        if (
          isValid(formValidation) &&
          !R.isNil(cardElement.element) &&
          !cardInvalid
        ) {
          const values = serialize(form, { hash: true });

          // step 1 create paymentMethod
          const { error, paymentMethod } =
            await cardElement.stripe.createPaymentMethod({
              type: "card",
              card: cardElement.element,
              billing_details: {
                address: {
                  city: values.billingCity,
                  country: values.billingCountry,
                  line1: values.addressLine1,
                  line2: values.addressLine2,
                  postal_code: values.zipCode,
                  state: values.billingState,
                },
                email: values.username,
                name: values.billingFullname,
                phone: values.billingPhone,
              },
            });

          if (paymentMethod) {
            const sType = R.find(R.propEq("id", values.subscriptionType))(
              subscriptionType
            );

            handleRegisterFormRequest({
              ...values,
              city: paymentMethod.billing_details.address.city,
              country: paymentMethod.billing_details.address.country,
              state: paymentMethod.billing_details.address.state,
              postal_code: paymentMethod.billing_details.address.postal_code,
              addressLine1: paymentMethod.billing_details.address.line1,
              addressLine2: paymentMethod.billing_details.address.line2,
              preferredLang: "en",
              paymentMethodId: paymentMethod.id,
              subscriptionType: sType.marketing_platform,
              priceId: sType.marketing_platform_id,
              promotion_code:
                hasPromoCode && isPromoCodeValid ? promoCode.id : undefined,
              isSandbox,
            });
          } else {
            setRegisterError({ error: error.message });
          }
        } else {
          setRegisterError({
            error: "message.error.registration_form_invalid",
          });
          for (const fieldValidation in formValidation) {
            if (!checkValidValue(formValidation[fieldValidation])) {
              setRegisterError({ error: formValidation[fieldValidation] });
            }
          }
          setRegisterFormValidation(formValidation);
        }
      } else if (isPaddle) {
        const formValidationPaddle = validate(form, {
          firstname: REQUIRED,
          lastname: REQUIRED,
          proshopName: REQUIRED,
          billingFullname: REQUIRED,
          billingCountry: REQUIRED,
          billingState: REQUIRED,
          billingCity: REQUIRED,
          addressLine1: REQUIRED,
          phone: REQUIRED,
          username: (value) => REQUIRED(value) || EMAIL(value),
          password: (value) => REQUIRED(value) || PASSWORD(value),
          verifyPassword: (value, data) =>
            REQUIRED(value) ||
            PASSWORD(value) ||
            (value !== data.password
              ? "message.error.password_confirmation"
              : undefined),
        });

        if (isValid(formValidationPaddle)) {
          const values = serialize(form, { hash: true });
          const sType = R.find(R.propEq("id", values.subscriptionType))(
            subscriptionType
          );

          paddleCheckout({
            items: [
              {
                priceId: sType.marketing_platform_id,
                quantity: 1,
              },
            ],
            discountCode:
              sType?.custom_data?.useAsDiscountCode === "true"
                ? referralCode || undefined
                : undefined,
            customer: {
              email: values.username,
              name: `${values.firstname} ${values.lastname}`,
              address: {
                countryCode: values.billingCountry,
                postalCode: values.zipCode,
                region: values.billingState,
                city: values.billingCity,
                firstLine: values.addressLine1 + " " + values.addressLine2,
                // secondLine: values.addressLine2,
              },
            },
            onComplete: (event) => {
              const form = registerFormRef.current;
              const values = serialize(form, { hash: true });
              const sType = R.find(R.propEq("id", values.subscriptionType))(
                subscriptionType
              );

              handleRegisterFormRequest({
                ...values,
                preferredLang: "en",
                subscriptionType: sType.marketing_platform,
                customer: event.data.customer.id,
                isSandbox,
              });
            },
            settings: {
              locale,
            },
            isSandbox,
          });

          // handleRegisterFormRequest({
          //   ...values,
          //   preferredLang: "en",
          //   subscriptionType: sType.marketing_platform,
          //   priceId: sType.marketing_platform_id,
          //   promotion_code:
          //     hasPromoCode && isPromoCodeValid ? promoCode.id : undefined,
          //   isSandbox,
          // });
        } else {
          setRegisterError({
            error: "message.error.registration_form_invalid",
          });
          for (const fieldValidation in formValidationPaddle) {
            if (!checkValidValue(formValidationPaddle[fieldValidation])) {
              setRegisterError({
                error: formValidationPaddle[fieldValidation],
              });
            }
          }
          setRegisterFormValidation(formValidationPaddle);
        }
      }
    };

    proccessCreateAccount();
  };

  const formControlStyle = { width: "100%" };
  const formTotalsStyle = {
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    marginBottom: "1em",
  };
  const formTotalsContainerStyle = {
    width: "100%",
    alignItems: "flex-start",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  };
  const createFormRow = { justifyContent: "center" };
  const containerRowStyle = { justifyContent: "center" };

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin();
    }
  };

  const onChange = () => {
    if (isStripe) {
      const values = serialize(registerFormRef.current, { hash: true });
      window.localStorage.setItem(
        "registrationForm",
        JSON.stringify(R.omit(["password", "verifyPassword"], values))
      );
      const sType = R.find(R.propEq("id", values.subscriptionType))(
        subscriptionType
      );

      if (!registrationQuote.id) {
        createRegistrationQuote({
          priceId: sType.marketing_platform_id,
          country: values.billingCountry,
          state: values.billingState,
          city: values.billingCity,
          addressLine1: values.addressLine1,
          // addressLine2: values.addressLine2,
          postal_code: values.zipCode,
          promotion_code:
            hasPromoCode && isPromoCodeValid ? promoCode.id : undefined,
          isSandbox,
        });
      } else {
        if (defaultFormValues.billingCountry !== values.billingCountry) {
          deleteRegistrationQuote({ quoteId: registrationQuote.id, isSandbox });
          const sTypeByCountry = subscriptionType.filter((sType) =>
            values.billingCountry === "CA"
              ? sType.description.indexOf("CAD") >= 0
              : sType.description.indexOf("CAD") < 0
          );

          const sTypeNew = sTypeByCountry[0];
          createRegistrationQuote({
            priceId: sTypeNew.marketing_platform_id,
            country: values.billingCountry,
            state: values.billingState,
            city: values.billingCity,
            addressLine1: values.addressLine1,
            addressLine2: values.addressLine2,
            postal_code: values.zipCode,
            promotion_code:
              hasPromoCode && isPromoCodeValid ? promoCode.id : undefined,
            isSandbox,
          });
        } else {
          updateRegistrationQuote({
            quoteId: registrationQuote.id,
            priceId: sType.marketing_platform_id,
            country: values.billingCountry,
            state: values.billingState,
            city: values.billingCity,
            addressLine1: values.addressLine1,
            addressLine2: values.addressLine2,
            postal_code: values.zipCode,
            promotion_code:
              hasPromoCode && isPromoCodeValid ? promoCode.id : undefined,
            isSandbox,
          });
        }
      }
    } else {
      const values = serialize(registerFormRef.current, { hash: true });
      window.localStorage.setItem(
        "registrationForm",
        JSON.stringify(R.omit(["password", "verifyPassword"], values))
      );
    }
  };

  return (
    <>
      {showLogin && !registeringUser && !requesting ? (
        <>
          {createAccount && (
            <RegisterHeader>
              <BackLink onClick={handleBack}>
                <FontAwesomeIcon
                  icon={["fas", "arrow-left"]}
                  style={logoStyle}
                />
                {t("general.back")}
              </BackLink>
              <HeaderTitle>
                <RegTitle>{t("form.label.registration")}</RegTitle>
                <WelcomeSub>{t("form.label.welcome")}</WelcomeSub>
              </HeaderTitle>
            </RegisterHeader>
          )}
          <ContainerStyle createAccount={createAccount} className="container">
            <div className="row container-row" style={containerRowStyle}>
              {createAccount ? (
                <>
                  <FormStretchStyle
                    $compact
                    ref={registerFormRef}
                    onSubmit={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  >
                    <div className="row" style={createFormRow}>
                      <div
                        className="col-12 col-md-12 col-lg-12"
                        style={{
                          paddingLeft: "1.5em",
                          paddingTop: "1.5em",
                        }}
                      >
                        <TitleCreate inputColor="2D7AC0">
                          {t("form.label.userinfo")}
                        </TitleCreate>
                      </div>
                    </div>
                    <div className="row" style={createFormRow}>
                      <SectionContainerCreate className="col-12 col-md-12 col-lg-6">
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.username}
                            type="email"
                            className="form-control"
                            id="createAccountEmailInput"
                            placeholder="name@example.com"
                            onFocus={handleFocusTextbox}
                            name="username"
                            isInvalid={
                              !checkValidValue(registerFormValidation.username)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountEmailInput">
                            {t("form.placeholder.email")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            type="password"
                            className="form-control"
                            id="createAccountPasswordInput"
                            placeholder={t("form.placeholder.password")}
                            onFocus={handleFocusTextbox}
                            name="password"
                            isInvalid={
                              !checkValidValue(registerFormValidation.password)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountPasswordInput">
                            {t("form.placeholder.password")}
                          </label>
                        </div>
                        <div className="form-floating" style={formControlStyle}>
                          <Form.Control
                            type="password"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.verify_password")}
                            onFocus={handleFocusTextbox}
                            name="verifyPassword"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.verifyPassword
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.verify_password")}
                          </label>
                        </div>
                      </SectionContainerCreate>
                      <SectionContainerCreate className="col-12 col-md-12 col-lg-6">
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.firstname}
                            type="text"
                            className="form-control"
                            id="createAccountEmailInput"
                            placeholder={t("form.placeholder.first_name")}
                            onFocus={handleFocusTextbox}
                            name="firstname"
                            isInvalid={
                              !checkValidValue(registerFormValidation.firstname)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountEmailInput">
                            {t("form.placeholder.first_name")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.lastname}
                            type="text"
                            className="form-control"
                            id="createAccountEmailInput"
                            placeholder={t("form.placeholder.last_name")}
                            onFocus={handleFocusTextbox}
                            name="lastname"
                            isInvalid={
                              !checkValidValue(registerFormValidation.lastname)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountEmailInput">
                            {t("form.placeholder.last_name")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.proshopName}
                            type="text"
                            className="form-control"
                            id="createAccountEmaiInput"
                            placeholder={t("form.placeholder.proshop_name")}
                            onFocus={handleFocusTextbox}
                            name="proshopName"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.proshopName
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountEmailInput">
                            {t("form.placeholder.proshop_name")}
                          </label>
                        </div>
                      </SectionContainerCreate>
                    </div>
                    <div className="row" style={createFormRow}>
                      <SectionContainerCreate
                        $twoCol
                        className="col-12 col-md-12 col-lg-12"
                      >
                        <div
                          className="col-12 col-md-12 col-lg-12"
                          style={{ paddingLeft: "0em" }}
                        >
                          <TitleCreate inputColor="2D7AC0">
                            {t("form.label.billinginfo")}
                          </TitleCreate>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.billingFullname}
                            type="text"
                            className="form-control"
                            id="createAccountEmailInput"
                            placeholder="name@example.com"
                            onFocus={handleFocusTextbox}
                            name="billingFullname"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.billingFullname
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountEmailInput">
                            {t("form.placeholder.billingFullname")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Select
                            defaultValue={defaultFormValues.billingCountry}
                            className="form-control"
                            id="createAccountPasswordInput"
                            placeholder={t("form.placeholder.country")}
                            onFocus={handleFocusTextbox}
                            name="billingCountry"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.billingCountry
                              )
                            }
                            onChange={(e) => {
                              SelectCountry(
                                countries[e.target.selectedIndex - 1].value
                              );
                              onChange();
                            }}
                          >
                            <option value=""></option>
                            {countries.map((country) => (
                              <option
                                value={country.value}
                                // selected={
                                //   country.value ===
                                //   defaultFormValues.billingCountry
                                // }
                              >
                                {country.countryName}
                              </option>
                            ))}
                          </Form.Select>
                          <label htmlFor="createAccountPasswordInput">
                            {t("form.placeholder.country")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Select
                            defaultValue={defaultFormValues.billingState}
                            className="form-control"
                            id="createAccountPasswordInput"
                            placeholder={t("form.placeholder.country")}
                            onFocus={handleFocusTextbox}
                            name="billingState"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.billingState
                              )
                            }
                            onChange={onChange}
                          >
                            <option value=""></option>
                            {getStates(selectedCountry, lang).map((state) => (
                              <option
                                value={state.value}
                                // selected={
                                //   state.value === defaultFormValues.billingState
                                // }
                              >
                                {state.stateName}
                              </option>
                            ))}
                          </Form.Select>
                          <label htmlFor="createAccountPasswordInput">
                            {t("form.placeholder.state")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.addressLine1}
                            type="text"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.addressLine1")}
                            onFocus={handleFocusTextbox}
                            name="addressLine1"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.addressLine1
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.addressLine1")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.addressLine2}
                            type="text"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.addressLine2")}
                            onFocus={handleFocusTextbox}
                            name="addressLine2"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.addressLine2
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.addressLine2")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.billingCity}
                            type="text"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.billingCity")}
                            onFocus={handleFocusTextbox}
                            name="billingCity"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.billingCity
                              )
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.billingCity")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.zipCode}
                            type="text"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.zipCode")}
                            onFocus={handleFocusTextbox}
                            name="zipCode"
                            isInvalid={
                              !checkValidValue(registerFormValidation.zipCode)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.zipCode")}
                          </label>
                        </div>
                      </SectionContainerCreate>
                      <SectionContainerCreate className="col-12 col-md-12 col-lg-12">
                        <div
                          className="col-12 col-md-12 col-lg-12"
                          style={{ paddingLeft: "0em" }}
                        >
                          <TitleCreate inputColor="2D7AC0">
                            {t("form.label.paymentinfo")}
                          </TitleCreate>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.referralCode}
                            type="text"
                            className="form-control"
                            id="referralCode"
                            placeholder={t("form.placeholder.referralCode")}
                            onFocus={handleFocusTextbox}
                            name="referralCode"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.referralCode
                              )
                            }
                            onChange={(event) => {
                              console.log(event.target.value);
                              setReferralCode({
                                referralCode: event.target.value,
                              });
                            }}
                          />
                          <label htmlFor="referralCode">
                            {t("form.placeholder.referralCode")}
                          </label>
                        </div>
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Select
                            defaultValue={defaultFormValues.subscriptionType}
                            className="form-control"
                            id="createAccountPasswordInput"
                            placeholder={t("form.placeholder.subscriptionType")}
                            onFocus={handleFocusTextbox}
                            name="subscriptionType"
                            isInvalid={
                              !checkValidValue(
                                registerFormValidation.subscriptionType
                              )
                            }
                            onChange={onChange}
                          >
                            {subscriptionTypeByCountry.map((sType) => (
                              <option
                                value={sType.id}
                                // selected={
                                //   sType.id ===
                                //   defaultFormValues.subscriptionType
                                // }
                              >
                                {sType.description
                                  .replace("CAD)", "CAD")
                                  .replace("USD)", "USD")}
                                $ {sType.price}){" "}
                                {sType.custom_data
                                  ? sType.custom_data.promoText
                                  : ""}
                              </option>
                            ))}
                          </Form.Select>
                          <label htmlFor="createAccountPasswordInput">
                            {t("form.placeholder.subscriptionType")}
                          </label>
                        </div>
                        {isStripe && (
                          <CardContainer
                            invalid={cardInvalid}
                            focused={cardFocus}
                            className="form-floating mb-3"
                          >
                            {stripeObject && (
                              <Elements stripe={stripeObject}>
                                <CardComponent
                                  setCardFocus={setCardFocus}
                                  setCardInvalid={setCardInvalid}
                                  setCardElement={setCardElement}
                                />
                              </Elements>
                            )}
                          </CardContainer>
                        )}
                        <div
                          className="form-floating mb-3"
                          style={formControlStyle}
                        >
                          <Form.Control
                            defaultValue={defaultFormValues.phone}
                            type="text"
                            className="form-control"
                            id="createAccountVerifyPasswordInput"
                            placeholder={t("form.placeholder.phone")}
                            onFocus={handleFocusTextbox}
                            name="phone"
                            isInvalid={
                              !checkValidValue(registerFormValidation.phone)
                            }
                            onChange={onChange}
                          />
                          <label htmlFor="createAccountVerifyPasswordInput">
                            {t("form.placeholder.phone")}
                          </label>
                        </div>
                        {isStripe && (
                          <div
                            className="form-floating mb-3"
                            style={formControlStyle}
                          >
                            <Form.Control
                              type="text"
                              className="form-control"
                              id="createAccountPasswordInput"
                              placeholder={t("form.placeholder.password")}
                              onFocus={handleFocusTextbox}
                              name="coupon"
                              onBlur={(e) => {
                                const values = serialize(
                                  registerFormRef.current,
                                  { hash: true }
                                );
                                const sType = R.find(
                                  R.propEq("id", values.subscriptionType)
                                )(subscriptionType);

                                let quoteValues = {};
                                if (!registrationQuote.id) {
                                  quoteValues = {
                                    priceId: sType.marketing_platform_id,
                                    country: values.billingCountry,
                                    city: values.billingCity,
                                    state: values.billingState,
                                    addressLine1: values.addressLine1,
                                    addressLine2: values.addressLine2,
                                    postal_code: values.zipCode,
                                    isSandbox,
                                  };
                                } else {
                                  quoteValues = {
                                    quoteId: registrationQuote.id,
                                    priceId: sType.marketing_platform_id,
                                    country: values.billingCountry,
                                    city: values.billingCity,
                                    state: values.billingState,
                                    addressLine1: values.addressLine1,
                                    addressLine2: values.addressLine2,
                                    postal_code: values.zipCode,
                                    isSandbox,
                                  };
                                }
                                getPromoCode({
                                  promoCode: e.target.value,
                                  isSandbox,
                                  quoteValues,
                                });
                              }}
                              onChange={(e) => {
                                clearPromoCode();
                                if (e.target.value !== "") {
                                  setHasPromoCode({ hasPromoCode: true });
                                } else {
                                  setHasPromoCode({ hasPromoCode: false });
                                }
                              }}
                              isInvalid={hasPromoCode && !isPromoCodeValid}
                            />

                            <label htmlFor="createAccountPasswordInput">
                              {t("form.placeholder.coupon")}
                            </label>
                            {validatingPromoCode && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <TailSpin width={35} height={35} />
                              </div>
                            )}
                            {!validatingPromoCode &&
                              hasPromoCode &&
                              showPromoCodeValid && (
                                <div
                                  style={{
                                    position: "absolute",
                                    right: 10,
                                    top: 0,
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "check"]}
                                    style={{ color: "green", fontSize: "2em" }}
                                  />
                                </div>
                              )}

                            {/* {!validatingPromoCode &&
                            hasPromoCode &&
                            showPromoCodeInvalid && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: 10,
                                  top: 0,
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={["fas", "xmark"]}
                                  style={{ color: "red", fontSize: "2em" }}
                                />
                              </div>
                            )} */}
                          </div>
                        )}
                        {isStripe && registrationQuote.id && (
                          <div
                            className="col-12"
                            style={formTotalsContainerStyle}
                          >
                            <div className="col-12" style={formTotalsStyle}>
                              {/* <TotalLabel>{t("upFront")}</TotalLabel> */}
                              <TotalLabel>
                                <div className="col-8">
                                  {t("subtotal")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.upfront
                                      .amount_subtotal / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("discounts")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.upfront
                                      .total_details.amount_discount / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("Taxes")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.upfront
                                      .total_details.amount_tax / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("Total")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.upfront
                                      .amount_total / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                            </div>
                            <div
                              className="col-12"
                              style={{
                                ...formTotalsStyle,
                                alignItems: "flex-start",
                              }}
                            >
                              <TotalLabel
                                style={{ textAlign: "left", fontSize: "0.8em" }}
                              >
                                *{t("recurring_disclaimer")}
                              </TotalLabel>
                              {/* <TotalLabel>
                                {t("recurring")} (
                                {t(
                                  registrationQuote.computed.recurring.interval
                                )}
                                )
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("subtotal")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.recurring
                                      .amount_subtotal / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("discounts")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.recurring
                                      .total_details.amount_discount / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("Taxes")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.recurring
                                      .total_details.amount_tax / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel>
                              <TotalLabel>
                                <div className="col-8">
                                  {t("Total")} ({currency}):
                                </div>
                                <div className="col-4">
                                  {(
                                    registrationQuote.computed.recurring
                                      .amount_total / 100
                                  ).toFixed(2)}
                                </div>
                              </TotalLabel> */}
                            </div>
                          </div>
                        )}
                      </SectionContainerCreate>
                    </div>
                    <Button
                      className="btn btn-primary"
                      type="button"
                      subs
                      onClick={() => {
                        handleCreateAccount();
                      }}
                    >
                      {t("form.label.checkout").toUpperCase()}
                    </Button>
                    <PolicyLabel>
                      {t("form.description.privacy_policy_text")}
                      <a
                        style={{
                          textDecoration: "underline",
                          marginLeft: "0.5em",
                        }}
                        href={"https://www.spectrebowling.com/legal"}
                        target="__blank"
                      >
                        {t("form.description.privacy_policy_link")}
                      </a>
                    </PolicyLabel>
                  </FormStretchStyle>
                </>
              ) : (
                <>
                  <SectionContainer
                    className={`col-12 col-md-12 col-lg-${
                      deviceInfo.isPortrait ? "12" : "6"
                    }`}
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "3em",
                      paddingTop: 0,
                      paddingBottom: 0,
                    }}
                  >
                    {/* TODO: modify logo dimensions, when mark update Xd platform */}
                    <LogoContainer src={logo} />
                    {/* <ImageLabel> {t("form.label.imageLabel")} </ImageLabel> */}
                  </SectionContainer>
                  <SectionContainer right className="col-12 col-md-12 col-lg-6">
                    <FormStretchStyle
                      ref={loginFormRef}
                      onSubmit={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    >
                      <StretchStyle>
                        <Title inputColor="2D7AC0">
                          {t("form.label.login")}
                        </Title>
                        <div className="form-floating mb-3">
                          <Form.Control
                            type="email"
                            placeholder="name@example.com"
                            name="username"
                            // El correo no se pierde: viene de la tienda que
                            // mandó aquí, o es el que se tecleó antes de que
                            // la clave fallara (ver routers/openStore.js).
                            defaultValue={loginEmailHint()}
                            onChange={(e) => rememberLoginEmail(e.target.value)}
                            onFocus={handleFocusTextbox}
                            required
                            isInvalid={invalid}
                            onKeyPress={onKeyPress}
                          />
                          <label htmlFor="floatingInput">
                            {t("form.placeholder.email")}
                          </label>
                        </div>
                        <div
                          className="form-floating"
                          style={{ position: "relative" }}
                        >
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder={t("form.placeholder.password")}
                            name="password"
                            onFocus={handleFocusTextbox}
                            // Con el correo ya puesto, lo que falta es la clave.
                            autoFocus={Boolean(loginEmailHint())}
                            required
                            isInvalid={invalid}
                            onKeyPress={onKeyPress}
                            // Sitio para el ojo; el icono de "inválido" de
                            // Bootstrap caería justo debajo, así que se quita
                            // (el borde rojo sigue avisando).
                            style={{ paddingRight: "3rem", backgroundImage: "none" }}
                          />
                          <label htmlFor="floatingPassword">
                            {t("form.placeholder.password")}
                          </label>
                          {/* Siempre a la vista y del tamaño de un dedo: v3 es
                              táctil, nada de mostrarlo sólo al pasar el ratón. */}
                          <button
                            type="button"
                            onClick={() => setShowPassword((v) => !v)}
                            aria-label={t(
                              showPassword
                                ? "form.label.hide_password"
                                : "form.label.show_password",
                            )}
                            aria-pressed={showPassword}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              height: "100%",
                              width: "3rem",
                              minWidth: 44,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: 0,
                              background: "transparent",
                              color: "#6c757d",
                              zIndex: 5,
                            }}
                          >
                            {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                          </button>
                        </div>
                        <div
                          style={{
                            marginTop: "1em",
                            alignSelf: "flex-start",
                            marginLeft: "1em",
                          }}
                        >
                          <a
                            style={{ textDecoration: "underline" }}
                            href={
                              "https://www.spectrebowling.com/passwordreset?no-cache=1"
                            }
                            target="__blank"
                          >
                            {t("forgot-password")}
                          </a>
                        </div>
                        <Button
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            handleLogin();
                          }}
                          loading={requesting}
                        >
                          {t("form.label.login").toUpperCase()}
                        </Button>
                        <PolicyLabel>
                          {t("form.description.privacy_policy_text")}
                          <a
                            style={{
                              textDecoration: "underline",
                              marginLeft: "0.5em",
                            }}
                            href={"https://www.spectrebowling.com/legal"}
                            target="__blank"
                          >
                            {t("form.description.privacy_policy_link")}
                          </a>
                        </PolicyLabel>
                        <Button
                          className="btn btn-primary"
                          subs
                          onClick={handleSubscription}
                        >
                          {t("form.label.subscribe").toUpperCase()}
                        </Button>
                      </StretchStyle>
                    </FormStretchStyle>
                  </SectionContainer>
                </>
              )}
            </div>
            {/* <FooterLabel active={tipping}>
              {t("form.description.login_footer_message")}{" "}
              {t("form.description.login_footer_website")}
            </FooterLabel> */}
          </ContainerStyle>
        </>
      ) : (
        <SpinnerContainer>
          <LoadingPage
            loadingMessage={
              registeringUser ? "general.registeringUser" : "general.Loading"
            }
          />
          <TailSpin />
        </SpinnerContainer>
      )}
    </>
  );
};

export default connect(
  (state) => ({
    lang: state.settings.language,
    requesting: state.userSession.requesting,
    deviceInfo: state.userSession.deviceInfo,
    error: state.userSession.error
      ? state.userSession.error
      : state.userSession.registerError
      ? state.userSession.registerError
      : "",
    invalid:
      state.userSession.error !== "" || state.userSession.registerError !== "",
    appStarted: state.userSession.appStarted,
    // isSandbox: state.userSession.isSandbox,
    // subscriptionType: state.userSession.subscriptionType.filter((sType) => {
    //   return state.userSession.isSandbox
    //     ? sType.marketing_platform === "PADDLE_SANDBOX"
    //     : sType.marketing_platform === "PADDLE";
    // }),
    isSandbox: apiConfig.isSandbox,
    referralCode: state.userSession.referralCode,
    subscriptionType:
      state.userSession.referralCode === ""
        ? state.userSession.subscriptionType.filter(
            (sType) =>
              sType.marketing_platform ===
                (apiConfig.isSandbox
                  ? `${apiConfig.payment_gateway}_SANDBOX`
                  : `${apiConfig.payment_gateway}`) &&
              (sType.referralCode === null || sType.referralCode === "")
          )
        : state.userSession.subscriptionType.filter(
            (sType) =>
              sType.marketing_platform ===
                (apiConfig.isSandbox
                  ? `${apiConfig.payment_gateway}_SANDBOX`
                  : `${apiConfig.payment_gateway}`) &&
              sType.referralCode === state.userSession.referralCode
          ),
    registeringUser: state.userSession.registeringUser,
    validatingPromoCode: state.userSession.validatingPromoCode,
    promoCode: state.userSession.promoCode,
    isPromoCodeValid: state.userSession.promoCode
      ? state.userSession.promoCode.id
        ? state.userSession.promoCode.id !== ""
          ? state.userSession.promoCode.active
          : false
        : false
      : false,
    showPromoCodeValid: state.userSession.promoCode
      ? state.userSession.promoCode.id
        ? state.userSession.promoCode.id !== ""
          ? state.userSession.promoCode.active
          : false
        : false
      : false,
    showPromoCodeInvalid: state.userSession.promoCode
      ? state.userSession.promoCode.id
        ? state.userSession.promoCode.id !== ""
          ? !state.userSession.promoCode.active
          : true
        : true
      : true,
    hasPromoCode: state.userSession.hasPromoCode,
    registrationQuote: state.userSession.registrationQuote,
    locale: state.settings.language,
    referralCode: state.userSession.referralCode,
  }),
  {
    handleLoginFormLoginRequest,
    handleRegisterFormRequest,
    setRegisterError,
    getSubscriptionType,
    getPromoCode,
    clearPromoCode,
    setHasPromoCode,
    createRegistrationQuote,
    updateRegistrationQuote,
    deleteRegistrationQuote,
    getRegistrationQuote,
    setReferralCode,
  }
)(LoginForm);
